import React, { useState, useEffect, useRef } from 'react';
import {
    IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
    IonButtons, IonButton, IonInput, IonItem, IonLabel, IonIcon, IonFooter, styles, IonCardSubtitle,
    IonGrid, IonRow, IonCol, IonItemDivider, IonDatetime, IonCard, IonCardHeader, IonCardTitle, IonCardContent,
    IonProgressBar, IonRadioGroup, IonRadio, IonText, useIonLoading, useIonToast, IonSegment, IonSegmentButton,
    IonNote, useIonModal, useIonAlert,
    IonAvatar
}
    from '@ionic/react';
import { chevronBackOutline, checkmarkSharp, eye, eyeOff, wallet, fingerPrint } from 'ionicons/icons';
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";

import axiosCall from '../data/axios';
import { Preferences } from '@capacitor/preferences';

import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from "capacitor-native-biometric";

import AuthContext from "../UserContext";
import { getCaptchaToken } from "../Helper";

import Auth from '../pages/Auth';

import { ProductStore } from "../data/ProductStore";
import { CartStore, removeFromCart, resetCart } from "../data/CartStore";
import { FeaturedStore } from '../data/FeaturedStore';
import { fetchData } from '../data/fetcher';

import PaymentForm from '../components/PaymentGateway';

function validateEmail(email) {
	const re = /^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/;
	return re.test(String(email).toLowerCase());
}

/*
const GuestForm = ({purchaserData, setPurchaserData}) => {
    const history = useHistory();
    const [phone, setPhone] = useState(purchaserData.userData.phone);

    const phoneVerifyBtnRef = useRef(null);
    
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const phoneRegex = /^(?:\+975|00975)?\d{8}$/;
    const auPhoneRegex = /^(\+61|0)4\d{8}$/;

    const [presentToast] = useIonToast();

    useEffect(() => {
        //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        //setNameError(name ? '' : 'Name is required');
        setPhoneError((phoneRegex.test(phone) || validateEmail(phone) || auPhoneRegex.test(phone)) ? '' : 'Invalid email / phone number');
        //setEmailError(emailRegex.test(email) ? '' : 'Invalid email address');

        if (phoneRegex.test(phone) || validateEmail(phone) || auPhoneRegex.test(phone)) {
            setPurchaserData({
                isExistingUser: false,
                isUserFormValid: false,
                userData: { phone: phone }
            });
        } else {
            setPurchaserData({
                isExistingUser: false,
                isUserFormValid: false,
                userData: {}
            });
        }
    }, [phone]);

    const SmsOtpModal = ({ dismiss }) => {
        const inputRef = useRef(null);
        let otpConfirm = function() {
            if (inputRef.current?.value) {
                dismiss({ otp: inputRef.current?.value }, 'confirm');
            }else {
                inputRef.current?.setFocus();
            }
        }
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle> Verify Phone/Email</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <IonItem className="ion-padding">
                        Please enter the OTP code that would have been sent to your Email or Bhutanese mobile number.
                    </IonItem>
                    <IonRow className="ion-padding">
                        <IonCol size="8" offset='2' className="ion-text-center">
                            <IonInput ref={inputRef} labelPlacement="floating" 
                                fill="outline" label="Enter the code here" type="number" />
                        </IonCol>
                    </IonRow>
                    <IonRow className="ion-padding">
                        <IonCol size="6" className="ion-text-end ion-align-self-center">
                            <IonNote>
                                SMS Powered by 
                            </IonNote>
                        </IonCol>
                        <IonCol size="6" className="ion-text-start ion-align-self-center">
                                <a href="https://www.somleng.org/" target="_blank" rel="noopener noreferrer">
                                    <img src="https://www.somleng.org/images/somleng_logo.png"
                                        className=""
                                        alt="Somleng Logo" height="50" />
                                </a>
                        </IonCol>
                    </IonRow>
                    <IonItemDivider/>
                    <IonItem>
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton color="medium" onClick={() => dismiss(null, 'cancel')}>
                                    Cancel
                                </IonButton>
                            </IonButtons>
                            <IonButtons slot="end">
                                <IonButton color="drukre" onClick={() => otpConfirm()} strong={true}>
                                    Confirm
                                </IonButton>
                            </IonButtons>
                        </IonToolbar>
                    </IonItem>
                </IonContent>
            </IonPage>
        );
    };

    const [presentOTP, setPresentOTP] = useIonModal(SmsOtpModal, {
        dismiss: (data, role) => setPresentOTP(data, role),
        backdropDismiss: false
    });
    
    const [spinnerPresent, spinnerDismiss] = useIonLoading();

    const processOTP = async () => {

        setPhoneError('');

        //Validate phone or email
        if (!phone || !(phoneRegex.test(phone) || validateEmail(phone) || auPhoneRegex.test(phone))) {
            setPhoneError("Enter a valid email/Bhutanese or Australian phone number");
            return;
        }

        // Retrieve the current verifiedPhoneOrEmail value
        let verifiedPhoneOrEmail = await Preferences.get({ key: 'verifiedPhoneOrEmail' });
        let verifiedData = verifiedPhoneOrEmail.value ? JSON.parse(verifiedPhoneOrEmail.value) : [];

        // Check if the phone number or email is already verified
        if (validateEmail(phone)) {
            if (verifiedData.includes(phone)) {
                setPurchaserData({
                    isExistingUser: false,
                    isUserFormValid: true,
                    userData: { phone: phone, email: phone}
                });
                presentToast({
                    message: 'Email address already verified!',
                    duration: 5000,
                    color: 'success'
                });
                return;
            }
        } else {
            if (verifiedData.some(item => item.slice(-8) === phone.slice(-8))) {
                setPurchaserData({
                    isExistingUser: false,
                    isUserFormValid: true,
                    userData: { phone: phone }
                });
                presentToast({
                    message: 'Phone number already verified!',
                    duration: 2000,
                    color: 'info',
                });
                return;
            }
        }

        spinnerPresent({
            message: 'Processing. Please wait...',
            spinner: 'bubbles',
            animated: true,
            cssClass: 'drukre-loading'
        });

        var captchaData = {
            captchaToken: '',
            captchaAction: ''
        };

        await getCaptchaToken('PAYMENT').then((token) => { // Here wait token generated
            if (token) {
                captchaData.captchaToken = token;
                captchaData.captchaAction = 'PAYMENT';
            }
        });

        //Fire backend rma api call
        axiosCall("/api/send-sms-verification", 'post', 
            { to: phone, captchaData: captchaData }, true)
        .then((res) => {
            if (res.data.status !== 1){
                setPhoneError('Phone/Email verification unsuccessful! ');
            }
            else {
                phoneVerifyBtnRef.current.disable = true;
                presentOTP({
                    initialBreakpoint: 0.5,
                    breakpoints: [0.35, 0.5, 0.7, 1],
                    backdropBreakpoint: 0,
                    backdropDismiss: false,
                    onWillDismiss: (ev) => {
                        if (ev.detail.role === 'confirm') {
                            (ev.detail).to = phone;
                            afterOTP(ev.detail);
                        }
                    }
                });
                setTimeout(function(){
                    if(phoneVerifyBtnRef.current)
                        phoneVerifyBtnRef.current.disable = false;
                }, 10000);
            }
        }).catch((error) => {
            setPhoneError("Phone/Email verification unsuccessful! "+ error.message);
            //setIserror(true);
        }).finally(() => {
            spinnerDismiss();
        });
    };

    function afterOTP(data) {

        spinnerPresent({
            message: 'Verifying Phone/Email. Please wait...',
            spinner: 'bubbles',
            animated: true,
            cssClass: 'drukre-loading'
        });

        axiosCall("/api/verify-sms", 'post', data, true)
        .then(async (res) => {
            if (res.data.status !== 1){
                setPhoneError('Phone/Email verification unsuccessful! ' + res.data.message);
            }
            else {
                setPurchaserData({
                    isExistingUser: false,
                    isUserFormValid: true,
                    userData: { phone: phone, email: validateEmail(phone) ? phone : ''}
                });
                
                // Retrieve the current verifiedPhoneOrEmail value
                let verifiedPhoneOrEmail = await Preferences.get({ key: 'verifiedPhoneOrEmail' });
                let verifiedData = verifiedPhoneOrEmail.value ? JSON.parse(verifiedPhoneOrEmail.value) : [];

                // Add the new phone number to the array if it doesn't already exist
                if (!verifiedData.includes(phone)) {
                    verifiedData.push(phone);
                }

                // Set the updated verifiedPhone value
                Preferences.set({
                    key: 'verifiedPhoneOrEmail',
                    value: JSON.stringify(verifiedData),
                });
            }
        }
        ).catch((error) => {
            setPhoneError('Phone/Email verification unsuccessful! ' + error.message);
        }).finally(() => {
            spinnerDismiss();
        });
    }

    return (
        <IonGrid>
            <IonRow>
                <IonCol>
                    <IonInput label="Mobile Number/Email" labelPlacement="floating" fill="outline" type="text" 
                        onIonChange={(e) => setPhone(e.detail.value)} required value={purchaserData.userData.phone}>
                    </IonInput>
                    <IonNote>If you are verifying a phone, only certain countries are supported.
                        {phoneError && <span style={{ fontSize: "small", color:"red", textAlign: "center", padding: "0 0 0 12px" }}>{phoneError}</span>}
                    </IonNote>
                 </IonCol>
            </IonRow>
            <IonRow className="ion-padding">
                <IonCol size="4" className="ion-text-end ion-align-self-center">
                    <IonNote>
                        SMS Powered by 
                    </IonNote>
                </IonCol>
                <IonCol size="2" className="ion-text-start ion-align-self-center">
                        <a href="https://www.somleng.org/" target="_blank" rel="noopener noreferrer">
                            <img src="https://www.somleng.org/images/somleng_logo.png"
                                className=""
                                alt="Somleng Logo" height="50" />
                        </a>
                </IonCol>
                <IonCol size="6" className="ion-text-end ion-align-self-center">
                    <IonButton className="ion-padding ion-float-right" color="drukre" onClick={processOTP} ref={phoneVerifyBtnRef}
                        disabled={purchaserData.isUserFormValid}>
                        <IonIcon icon={checkmarkSharp} />&nbsp; Verify Phone/Email
                    </IonButton>
                </IonCol>
            </IonRow>
            <p style={{ fontSize: "small", textAlign: "center"  }}>
                    By continueing you agree to our <span onClick={() => history.push("/terms-and-conditions")}>Terms and Conditions</span>
            </p>
            
            {error && <p>{error}</p>}

        </IonGrid>
    );
};
*/

const LoginForm = ({ setIsAuthenticated, setPurchaserData }) => {

    const history = useHistory();

    useEffect(() => {
        setPurchaserData({
          isExistingUser: false,
          isUserFormValid: false,
          userData: {}
        });
    }, [setPurchaserData]);
    
    const [email, setEmail] = useState("");

    const { updateUser } = React.useContext(AuthContext);
    
    const afterLoginExecution = async (nextAuthValues) => {
        await updateUser(nextAuthValues);
        setIsAuthenticated(true);

        const freshUserData = nextAuthValues?.user?.data || {};
        setPurchaserData({
            isExistingUser: true,
            isUserFormValid: true,
            userData: freshUserData
        });
    };

    return (
        <Auth embedded={true} afterLoginExecution={afterLoginExecution} />
    );
};

export const UserDetailsForm = ({purchaserData, setPurchaserData}) => {

    const { authValues, fetchUser, logout } = React.useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(authValues.authenticated);

    useEffect(() => {
        if(isAuthenticated)
            setPurchaserData(
                {
                    isExistingUser: true,
                    isUserFormValid: true,
                    userData: authValues.user.data
                }
            );
    }, [isAuthenticated, setPurchaserData, authValues.user.data]);

    return (
        <>
            {!isAuthenticated ? (
                <>
                    <LoginForm setIsAuthenticated={setIsAuthenticated} setPurchaserData={setPurchaserData}/>
                </>
            ) :
                <>
                    <p style={{ fontSize: "small", textAlign: "center" }}>
                        Processing the order on the user account session.
                    </p>
                    <IonText>
                        <p style={{ fontSize: "small", textAlign: "center" }}>
                            You are logged in as <IonNote>{authValues.user.data.email}</IonNote> 
                            {authValues.user.data.phone && 
                                <span> with phone <IonNote>{authValues.user.data.phone} </IonNote></span> }
                        </p>
                        <p style={{textAlign: "center"}}>
                            Please cross check your details before proceeding.
                        </p>
                    </IonText>
                </>
            }
        </>
    )
};

const Checkout = () => {
    const [step, setStep] = useState(1);

    const handleNextStep = () => {
        setStep(step + 1);
    };

    const handlePreviousStep = () => {
        setStep(step - 1);
    };

    const getProgressValue = () => {
        return step === 1 ? 0.5 : 1;
    };

    const history = useHistory();

    const { authValues, fetchUser, logout } = React.useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(authValues.authenticated);

    const [ purchaserData, setPurchaserData ] = useState({
        isExistingUser: false,
        isUserFormValid: false,
        userData: {}
    });

    const [total, setTotal] = useState(0);

    const products = ProductStore.useState(s => s.products);
    const productsFullyLoaded = ProductStore.useState(s => s.fullyLoaded);
    const shopCart = CartStore.useState(s => s.product_ids);

    useEffect(() => {

        const getCartProducts = () => {

            setTotal(0);

            shopCart.forEach(product => {
            
                var cartParts = product;
                var categorySlug = cartParts.categorySlug;
                var productID = cartParts.productID;

                var deliveryLocID = cartParts.newDeliveryLocID ? parseInt(cartParts.newDeliveryLocID) : null;
                var dzongkhag = cartParts.dzo;
                var address = cartParts.address;
                var delPrice = cartParts.price;
                var quantity = cartParts.quantity;

                const tempCategory = products.filter(p => p.slug === categorySlug)[0];
                const tempProduct = tempCategory.products.filter(p => parseInt(p.id) === parseInt(productID))[0];

                setTotal(prevTotal => prevTotal + parseInt(tempProduct.price * quantity));
                delPrice && setTotal(prevTotal => prevTotal + parseInt(delPrice));
            });
        }

        if(productsFullyLoaded)
            getCartProducts();
    }, [productsFullyLoaded, shopCart]);

    const [presentAlert] = useIonAlert();
    const onCompletion = (message) => {
        resetCart();
        /*Reload products
        ProductStore.update(s => {
            s.products = [];
            s.hasLoaded = false;
        });
        ProductStore.update(s => {
            s.fullyLoaded = false;
        });
        FeaturedStore.update(s => {
            s.products = [];
            s.hasLoaded = false;
        });
        fetchData();
        */
        //history.push('/cart');
        presentAlert({
            header: 'Thank you for your purchase!',
            subHeader: 'Please note your order number. You will be redirected now...',
            message: message ? message : 'Order placed successfully!',
            cssClass: 'copyable-alert',
            buttons: [
                {
                    text: 'OK',
                    handler: () => {
                        if(isAuthenticated)
                            window.location.href = '/my-purchases';
                        else 
                            window.location.href = '/track-order';
                    }
                }
            ]
        });
    }
    
    if(shopCart.length == 0)
    {
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Checkout</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle>Cart is Empty</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p style={{ fontSize: "medium" }} className="ion-text-center">
                                Please add some items to the cart before proceeding to checkout.
                            </p>
                        </IonCardContent>
                    </IonCard>
                </IonContent>
            </IonPage>
        );
    }
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="dark" text="Back to Cart" routerLink="/cart" routerDirection="back">
                            <IonIcon color="dark" icon={chevronBackOutline} />&nbsp;Back
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Checkout</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="page-content">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="dark" text="Back to Cart" routerLink="/cart" routerDirection="back">
                            <IonIcon color="dark" icon={chevronBackOutline} />&nbsp;Back
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Order Confirmation</IonTitle>
                </IonToolbar>
                <IonGrid>
                    <IonRow>
                        <IonCol className="ion-align-self-center" size-md="6" offset-md="3">
                            <br></br>
                            <IonProgressBar color="drukre" value={getProgressValue()}></IonProgressBar>
                            {step === 1 && <UserDetailsForm purchaserData={purchaserData}
                                setPurchaserData={setPurchaserData} onNext={handleNextStep} />}
                            {step === 2 && <PaymentForm purchaserData={purchaserData} payLoad={shopCart} 
                                api= '/api/orders' total={total} onSuccess={onCompletion} onPrevious={handlePreviousStep} />}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <div className="step-navigation ion-text-center">
                                {step > 1 && (
                                    <IonButton color="medium" className="ion-padding" onClick={handlePreviousStep}>
                                        <IonIcon icon={chevronBackOutline} /> Back
                                    </IonButton>
                                )}
                                {step < 2 && (
                                    <IonButton color="drukre" disabled={!purchaserData.isUserFormValid} className="ion-padding" onClick={handleNextStep}>
                                        Go to Payment <IonIcon icon={chevronBackOutline} style={{ transform: 'rotate(180deg)' }} />
                                    </IonButton>
                                )}
                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
            <IonFooter>
                {/*
                <IonButton color="drukre"  disabled={!isPaid}>
                    <IonIcon icon={checkmarkSharp}/>&nbsp;Confirm Order
                </IonButton>
                */}
                
            </IonFooter>
        </IonPage>
    );
};

export default Checkout;



// STRIPE src/pages/Checkout.js

/*
import React, { useState } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonInput, IonItem, IonLabel } from '@ionic/react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe('your-publishable-key-from-stripe');

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name,
        email,
      },
    });

    if (error) {
      setError(error.message);
      return;
    }

    // Send paymentMethod.id to your server to create a payment intent
    // For example:
    // const response = await fetch('/create-payment-intent', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ payment_method: paymentMethod.id }),
    // });
    // const paymentIntent = await response.json();

    setSuccess(true);
  };

  return (
    <form onSubmit={handleSubmit}>
      <IonItem>
        <IonLabel position="stacked">Name</IonLabel>
        <IonInput value={name} onIonChange={(e) => setName(e.detail.value)} required />
      </IonItem>
      <IonItem>
        <IonLabel position="stacked">Email</IonLabel>
        <IonInput type="email" value={email} onIonChange={(e) => setEmail(e.detail.value)} required />
      </IonItem>
      <IonItem>
        <IonLabel position="stacked">Card Details</IonLabel>
        <CardElement />
      </IonItem>
      {error && <p>{error}</p>}
      {success ? (
        <p>Payment Successful!</p>
      ) : (
        <IonButton type="submit" disabled={!stripe}>
          Pay
        </IonButton>
      )}
    </form>
  );
};

const Checkout = () => (
  <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonTitle>Checkout</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <Elements stripe={stripePromise}>
        <CheckoutForm />
      </Elements>
    </IonContent>
  </IonPage>
);

export default Checkout;
*/
